<template>
    <div class="imgs-item">
        <p class="vertical-letter"><span>{{tab}}</span></p>
        <div class="imgs-item-content">
            <router-link
                v-for="(item, idx) in imgList"
                :key="item.ThumbnailURL"
                :to="{
                    name: 'IMAGE_DETAIL',
                    query: {
                        sername: carSeriesInfo.name,
                        tab,
                        index: item.ImageIndexNumber - 1
                    },
                    params: {
                        serid: carSeriesInfo.id
                    }
                }"
                target="_blank"
            >
                <img
                    :key="item.ThumbnailURL"
                    src="@/assets/images/bitmap-small.png"
                    v-real-src="item.ThumbnailURL"
                    @click="logImgClick(tab, idx)"
                />
            </router-link>
        </div>
        <router-link
            :to="{
                name: 'IMAGE_DETAIL',
                query: {
                    sername: carSeriesInfo.name,
                    tab
                },
                params: {
                    serid: carSeriesInfo.id
                }
            }"
            class="vertical-letter vertical-letter-icon more"
            @click="this.logImgClick('更多')"
            target="_blank"
        >
            <span>更多</span>
            <img src="@/common/images/car-train/right-arrow-2.svg" />
        </router-link>
    </div>
</template>
<script>
/**
 * @file
 * @author
 */
import {sendLog} from 'js/log';

export default {
    props: {
        imgList: Array,
        tab: String,
        carSeriesInfo: Object
    },
    methods: {
        logImgClick(tab, pos) {
            const {
                name = '',
                brandName = '',
                id = ''
            } = this.carSeriesInfo || {};
            sendLog('car_train_image_click', {
                tab,
                name,
                brandName,
                seriesId: id,
                pos
            });
        }
    }
};
</script>

<style lang="less" scoped>
.imgs-item {
    display: flex;
    height: 142px;
    margin-top: 18px;
    background: #f8f8f8;
    .vertical-letter {
        width: 48px;
        height: 100%;
        font-size: 18px;
        color: #333333;
        background: #f8f8f8;
    }
}
.imgs-item-content {
    overflow: hidden;
    a {
        float: left;
        margin-left: 9px;
        &:first-child {
            margin-left: 0;
        }
    }
    img {
        width: 213px;
        height: 100%;
        cursor: pointer;
    }
}
</style>